module.exports = __webpack_public_path__ + "assets/photo.png";


//////////////////
// WEBPACK FOOTER
// ./images/photo.png
// module id = 313
// module chunks = 0